export default "__VITE_ASSET__a1662d15__"